document.addEventListener('DOMContentLoaded', function() {
  const hiddenRows = document.querySelectorAll('.testimonial-row.hidden');
  const readMoreBtn = document.getElementById('read-more-btn');
  let visibleRowCount = 1; // Start with 1 visible row

  readMoreBtn.addEventListener('click', function() {
    // Reveal the next hidden row
    if (visibleRowCount < hiddenRows.length + 1) {
      hiddenRows[visibleRowCount - 1].classList.remove('hidden');
      visibleRowCount++;
    }

    // Hide the button when all rows are revealed
    if (visibleRowCount >= hiddenRows.length) {
      readMoreBtn.style.display = 'none';
    }
  });
});